module.exports = __webpack_public_path__ + "img/T and C Icon - charcoal.728eef48.svg";